<div class="container-fluid mt-top-end-navbar">
	<h3 class="mt- text-uppercase">{{ "MENU.SERVICES" | translate }}</h3>
	<div class="row no-gutters submenu">
		<div class="submenu-block pr-3 pb-3">
			<p class="submenu-title">
				<a href="javascript:void(0);" routerLink="/pon">{{ "SERVICES_MENU.PON" | translate }}</a>
			</p>
			<p class="submenu-text">{{ "SERVICES_MENU.OPEN_STREAM" | translate }}</p>
			<p class="submenu-text">{{ "SERVICES_MENU.OPEN_INTERNET" | translate }}</p>
		</div>
		<div class="submenu-block pr-3 pb-3">
			<p class="submenu-title">
				<a href="javascript:void(0);" routerLink="/p2p-access">
					{{ "SERVICES_MENU.POINT_TO_POINT" | translate }}
				</a>
			</p>
			<p class="submenu-text">{{ "SERVICES_MENU.DARK_FIBER" | translate }}</p>
			<p class="submenu-text">{{ "SERVICES_MENU.ETHERNET" | translate }}</p>
		</div>
		<div class="submenu-block pr-3">
			<p class="submenu-title">
				<a href="javascript:void(0);" routerLink="/transport-infrastructure">
					{{ "SERVICES_MENU.TRANSPORT_COLO" | translate }}
				</a>
			</p>
			<p class="submenu-text">{{ "SERVICES_MENU.WAVELENGTH" | translate }}</p>
			<p class="submenu-text">{{ "SERVICES_MENU.COLOCATION" | translate }}</p>
		</div>
	</div>
</div>
